export enum LearningTrailsMenuEnum {
  trails,
  uc,
  ivca,
}
